export const addWord = {
  // Validation
  loginRequired: 'You need to be logged in',
  required: 'The word and meaning are required',
  submitFailed: 'Submission failed. Please try again.',

  // Done
  doneTitle: 'Submitted!',
  doneBody: 'Your submission will be published after admin approval.<br />Please wait a moment.',
  continuePosting: 'Post another',
  toWordPool: 'Go to Word Pool',

  // Header
  back: '← Back to Word Pool',
  heading: 'Add a Word',
  poster: 'Posted by: ',

  // Labels
  languageLabel: 'Language *',
  phraseLabel: 'Word / Phrase *',
  phrasePlaceholder: 'e.g.: Otsukaresama',
  readingLabel: 'Reading / Pronunciation',
  readingPlaceholder: 'e.g.: Otsukaresama',
  meaningLabel: 'Meaning (English) *',
  meaningPlaceholder: 'e.g.: Good work today / Thank you for your effort',
  usageLabel: 'Usage / Context',
  usagePlaceholder: 'When is it used?',
  lessonDateLabel: 'Lesson date',

  // Submit
  submitting: 'Submitting...',
  submit: 'Submit',
  note: '* After submission, it will be published once an admin approves it',
};
